import { call, put, takeLatest, delay } from 'redux-saga/effects';
import {
    SUBMIT_PARTNER_SIGNUP_FORM,
    RESEND_PARTNER_EMAIL,
    setPartnerSignupStatus,
    setPartnerSignupIsLoading,
    setPartnerSignupEmailSent,
} from './actions';
import PartnerSignupService from './service';
import { setGeneralError } from '../appLoadingState/actions';

const partnerSignupService = new PartnerSignupService();

export function* submitPartnerSignupForm(action) {
    try {
        yield put(setPartnerSignupStatus(null, null));
        yield put(setPartnerSignupIsLoading(true));

        const { success, message: errorCode } = yield call(partnerSignupService.submitPartnerSignupForm, action.data);

        window.mixpanel.track('partner_sign_up_submit', {
            name: action.data.fullName,
            signup_email: action.data.email,
            company_name: action.data.companyName,
            has_live_integration: action.data.hasLiveIntegration,
            working_with_advertisers: action.data.workingWithAdvertisers,
            server_error: errorCode,
            success: (!!success).toString(),
        });

        yield put(setPartnerSignupIsLoading(false));
        yield put(setPartnerSignupStatus(success ? 'success' : 'error', errorCode));
    } catch (res) {
        console.error(res);
        yield put(setPartnerSignupIsLoading(false));
        yield put(setPartnerSignupStatus('error', res.message));

        window.mixpanel.track('partner_sign_up_submit', {
            name: action.data.fullName,
            signup_email: action.data.email,
            company_name: action.data.companyName,
            has_live_integration: action.data.hasLiveIntegration,
            working_with_advertisers: action.data.workingWithAdvertisers,
            server_error: res.message,
            success: 'false',
        });
    }
}

export function* resendPartnerEmail(action) {
    try {
        yield put(setPartnerSignupIsLoading(true));
        yield put(setPartnerSignupEmailSent(false));

        yield call(partnerSignupService.resendEmail, action.data);

        yield put(setPartnerSignupIsLoading(false));
        yield put(setPartnerSignupEmailSent(true));

        yield delay(10000);
        yield put(setPartnerSignupEmailSent(false));
    } catch (res) {
        if (res.message) {
            yield put(setGeneralError(res.message));
        } else {
            yield put(setGeneralError());
        }
        console.error(res);
        yield put(setPartnerSignupIsLoading(false));
        yield put(setPartnerSignupEmailSent(false));
    }
}

function* watchPartnerSignup() {
    yield takeLatest(SUBMIT_PARTNER_SIGNUP_FORM, submitPartnerSignupForm);
    yield takeLatest(RESEND_PARTNER_EMAIL, resendPartnerEmail);
}

export const watchers = [watchPartnerSignup];
